import { createContext } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';

const ajs = new AnalyticsBrowser();
export const AnalyticsContext = createContext<AnalyticsBrowser>(ajs);
